/**
 * Chat Files Service
 * Servicio para procesar archivos adjuntos en mensajes de chat
 * Reemplaza uploadImageToS3 y uploadPdfToS3 de AGTHallService
 */

import axios from 'axios';

// Configurar base URL - asegurar que siempre termine en /api
const getBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';
  return envUrl.endsWith('/api') ? envUrl : `${envUrl}/api`;
};

const API_BASE_URL = getBaseUrl();

/**
 * Procesa archivos adjuntos para mensajes de chat
 * Usa el sistema avanzado de procesamiento del backend
 *
 * @param {string} userId - ID del usuario
 * @param {File[]} files - Array de archivos a procesar
 * @returns {Promise<Object>} Resultado del procesamiento con extractedText para cada archivo
 */
export const processChatFiles = async (userId, files) => {
  try {
    const formData = new FormData();

    // Agregar userId
    formData.append('userId', userId);

    // Agregar archivos
    files.forEach((file) => {
      formData.append('files', file);
    });

    const response = await axios.post(
      `${API_BASE_URL}/chat/process-files`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 120000, // 2 minutos
      }
    );

    return response.data;
  } catch (error) {
    console.error('[ChatFiles] Processing error:', error);
    throw new Error(
      error.response?.data?.error || error.message || 'Error processing chat files'
    );
  }
};

/**
 * Procesa un solo archivo (wrapper para compatibilidad)
 *
 * @param {File} file - Archivo a procesar
 * @param {string} userId - ID del usuario
 * @returns {Promise<Object>} Información del archivo procesado
 */
export const processSingleFile = async (file, userId) => {
  try {
    const result = await processChatFiles(userId, [file]);

    if (result.files && result.files.length > 0) {
      return result.files[0];
    }

    throw new Error('No file was processed');
  } catch (error) {
    console.error('[ChatFiles] Single file processing error:', error);
    throw error;
  }
};

export default {
  processChatFiles,
  processSingleFile,
};
